export default __webpack_public_path__ + "static/media/app-screen-2.cfc0750b.png";